import { marketplaces } from "@porsche-customer/slfinpub-marketplace-configuration"
import type { MarketplaceKey } from "@porsche-customer/slfinrtl-context-types"

/**
 * Some marketplaces (e.g. dk, fi, is) are not supported by the customer app and are therefore
 * missing from `marketplaces`. Returns an empty array for those instead of throwing.
 */
export const getCustomerAppLanguageTags = (marketplaceKey: MarketplaceKey): string[] => {
	return marketplaceKey in marketplaces ? marketplaces[marketplaceKey as keyof typeof marketplaces].languageTags : []
}
